import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/fonts.css'
import 'katex/dist/katex.min.css'
import './styles/global.css.ts'
import '@shared/lib/gsap'
import { App } from './App'

const rootElement = document.getElementById('root')!

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)

// index.html이 심어 둔 스피너 스플래시를, React가 첫 프레임을 실제로 페인트한
// 뒤(rAF 2회) 페이드아웃 후 제거한다. transitionend가 누락돼도 setTimeout이 정리.
function hideSplash() {
  const splash = document.getElementById('app-splash')
  if (!splash) return
  splash.classList.add('app-splash--hidden')
  const remove = () => splash.remove()
  splash.addEventListener('transitionend', remove, { once: true })
  setTimeout(remove, 600)
}
requestAnimationFrame(() => requestAnimationFrame(hideSplash))
